import React, { useState, useEffect, useRef } from 'react';
import './SearchUsersModal.css';
import { userService, conversationsService } from '../services';
import { useNavigate } from 'react-router-dom';

export default function SearchUsersModal({ isOpen, onClose }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        try { inputRef.current?.focus(); } catch (e) {}
      }, 80);
    }
  }, [isOpen]);

  // Close on Escape
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape' && isOpen) {
        onClose && onClose();
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  const handleSearch = async () => {
    try {
      setLoading(true);
      const res = await userService.searchUsers(query, 1, 10);
      setResults(Array.isArray(res) ? res : (res?.items || []));
    } catch (err) {
      console.error('User search failed', err);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleStartChat = async (userId) => {
    try {
      const conv = await conversationsService.startConversationWithUser(userId);
      const convId = conv?.id || conv?.conversationId || conv?._id;
      if (convId) {
        localStorage.setItem('openConversationId', convId);
        onClose && onClose();
        navigate('/free-chat/messenger');
      } else {
        alert('Could not create conversation');
      }
    } catch (err) {
      console.error('Start chat from search failed', err);
      alert('Failed to start chat');
    }
  };

  if (!isOpen) return null;

  const onOverlayClick = (e) => {
    // close only if clicking directly on overlay (not the modal itself)
    if (e.target && e.target.classList && e.target.classList.contains('search-users-modal-overlay')) {
      onClose && onClose();
    }
  };

  return (
    <div className="search-users-modal-overlay" onMouseDown={onOverlayClick}>
      <div className="search-users-modal" onMouseDown={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Tìm người dùng</h3>
          <button onClick={onClose} className="modal-close">✕</button>
        </div>
        <div className="modal-body">
          <div className="search-row">
            <input ref={inputRef} value={query} onChange={e => setQuery(e.target.value)} placeholder="Tìm kiếm tên hoặc username" />
            <button onClick={handleSearch} disabled={loading}>{loading ? '...' : 'Tìm'}</button>
          </div>
          <div className="results">
            {results.length === 0 ? <div className="no-results">Không có kết quả</div> : (
              results.map(u => (
                <div key={u.id || u.userId || u.user_id} className="result-item">
                  <div className="result-info">
                    <div className="avatar">{u.avatarUrl ? <img src={u.avatarUrl} alt="avatar" /> : '👤'}</div>
                    <div className="meta">
                      <div className="name">{u.displayName || u.fullName || u.username}</div>
                      <div className="sub">{u.email || u.username || ''}</div>
                    </div>
                  </div>
                  <div className="result-actions">
                    <button onClick={() => handleStartChat(u.id || u.userId || u.user_id)}>Start Chat</button>
                    <a href={`/profile/${u.id || u.userId || u.user_id}`} className="view-profile">View</a>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
